<div class="upload-status-modal-content">
    <h2>{{ data.message }}</h2>
    <div class="upload-status-spinner">
        <app-spinner></app-spinner>
    </div>
</div>